import './ErrorInfo.scss';

import { ReactComponent as ErrorIcon } from 'images/icons/Error.svg';
import i18next from 'i18next';

type Props = {
  errorMsg?: string;
  position?: React.CSSProperties['position'];
};

export const ErrorInfo = ({ errorMsg = i18next.t('ThisFieldIsRequired', { ns: 'general' }), position }: Props) => {
  return (
    <span className='error-info' style={{ position: position ?? 'absolute' }}>
      <ErrorIcon />
      <span>{errorMsg}</span>
    </span>
  );
};

export default ErrorInfo;
